import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';
/*

Props:

*/

const StyledStrong = styled.strong`

    font-weight: 400;
    @media (max-width: ${props => (props.noBreakPoint) ? '0' : constants.layout.breakpoint.break1}px){
        
    }
`;


const Strong = ({ style, onClick, children, ...rest }) => (
    <StyledStrong style = {style}  onClick = {onClick} {...rest} >
        { children }
    </StyledStrong>
) 

export default Strong;


// WEBPACK FOOTER //
// ./src/js/components/TextModifiers/Strong.jsx